<div class="content-margin">
  <section class="reservations-section">
    <h1 class="ewrs-page-title">My bookings</h1>

    <!-- <div class="ontario-alert ontario-alert--warning check-in-notice" role="alert">
        <div class="ontario-alert__header">
          <div class="ontario-alert__header-icon">
            <img src="assets/images/ontario-icon-alert-warning.svg" alt="" aria-hidden="true" />
          </div>
          <p class="check-in-notice__message">
            Your booking will be cancelled if you don't check in from an OPS location by
            <strong>10:00 am for all day/morning bookings, 1:00 pm for afternoon bookings.</strong>
          </p>
        </div>
      </div> -->

    <div class="mt-2 table-container">
      <app-table
        [dataSource]="dataSource"
        [visibleRows]="myBookingsData"
        [columns]="myBookingsTableColumns"
        [length]="(dataSource.dataCount$ | async) ?? 0"
        [pageIndex]="myBookingsPageIndex"
        [pageSize]="myBookingsPageSize"
        [pageSizeOptions]="myBookingsPageSizeOptions"
        [showRangeSummary]="true"
        [resultNoun]="'results'"
        [rowHeight]="80"
        [headerRowHeight]="44"
        [selectableRows]="true"
        [selectedRowIds]="selectedReservationIds"
        [rowSelectable]="canSelectMyBooking"
        [selectionNoun]="'booking'"
        [selectionActionLabel]="'Cancel bookings'"
        [selectionDisabled]="isBulkCancelling"
        [selectionIdPrefix]="'my-bookings-selection'"
        (pageChanged)="onMyBookingsPageChanged($event)"
        (actionButtonClick)="onMyBookingsActionButtonClick($event)"
        (rowSelectionChanged)="onMyBookingSelectionChanged($event)"
        (visibleSelectionChanged)="onVisibleMyBookingSelectionChanged($event)"
        (selectionCleared)="clearSelectedBookings()"
        (selectionAction)="cancelSelectedBookingsClicked()"
      ></app-table>
    </div>
    <div class="issue-divider">
      <mat-divider></mat-divider>
    </div>
    <app-create-issue></app-create-issue>
  </section>
  <div [hidden]="!isSuperUser">
    <div class="issue-divider">
      <mat-divider></mat-divider>
    </div>
    <section class="reservations-section">
      <h1 class="ewrs-page-title">Search for a booking</h1>

      <div class="mt-2">
        <app-ods-input
          class="reservation-search"
          [labelText]="'Search bookings by user email'"
          [labelFor]="'reservationSearchInput'"
          [labelId]="'reservationSearchLabel'"
        >
          <mat-form-field>
            <input
              id="reservationSearchInput"
              matInput
              [formControl]="reservationSearchControl"
              aria-labelledby="reservationSearchLabel"
            />
          </mat-form-field>
        </app-ods-input>
      </div>

      <div class="mt-2 table-container">
        <app-table
          class="search-bookings-table"
          [dataSource]="dataSourceAll"
          [columns]="searchBookingsTableColumns"
          [length]="(dataSourceAll.dataCount$ | async) ?? 0"
          [pageIndex]="searchBookingsPageIndex"
          [pageSize]="searchBookingsPageSize"
          [pageSizeOptions]="searchBookingsPageSizeOptions"
          [showRangeSummary]="true"
          [resultNoun]="'results'"
          [rowHeight]="80"
          [headerRowHeight]="44"
          (pageChanged)="onSearchBookingsPageChanged($event)"
          (actionButtonClick)="onSearchBookingsActionButtonClick($event)"
        ></app-table>
      </div>
    </section>
  </div>
</div>
